import { Component, Input } from '@angular/core';
import { StatLocation, StatSource } from '../../../../common/models/statistics/stat-data';
import { GoogleMapsModule } from '@angular/google-maps';
import { SharedModule } from '../../../../common/shared.module';
import { NgForOf, NgIf } from '@angular/common';
import { BasicStatDetailsComponent } from './basic-stat-details/basic-stat-details.component';

@Component({
  selector: 'psc-stat-data-map',
  templateUrl: './stat-data-map.component.html',
  standalone: true,
  imports: [
    GoogleMapsModule,
    SharedModule,
    NgForOf,
    NgIf,
    BasicStatDetailsComponent,
  ],
})
export class StatDataMapComponent {
  @Input() set statistics(statistics: StatLocation[]) {
    if (!statistics) {
      return;
    }
    this.markers = statistics.map((position) => ({
      position: {
        lat: +position.lat,
        lng: +position.lng,
      },
      options: {
        icon: {
          url: `assets/images/${ this.getMarkerIcon(position) }.png`,
          scaledSize: new google.maps.Size(15, 15),
        },
      },
      statLocationData: position,
    }));
  }

  private getMarkerIcon(location: StatLocation): string {
    const source = location.statistics.find((stat) => !!stat.source?.trim())?.source?.trim().toUpperCase() as StatSource | undefined;

    if (!source) {
      return 'sun_icon_blue';
    }

    if (source === StatSource.WEB) {
      return 'sun_icon';
    }

    if (source === StatSource.EPHZHB) {
      return 'sun_icon_red';
    }

    if (source === StatSource.OTP_BANK) {
      return 'sun_icon_green';
    }

    return 'sun_icon';
  }

  @Input() set locationData(value: google.maps.LatLngLiteral) {
    if (!value) {
      return;
    }
    this.center = value;
    this.mapZoom = 18;
    document.getElementById('adminDashboardMap')?.scrollIntoView({ behavior: 'smooth' });
  }

  selectedLocationData: StatLocation;
  markers: StatMarker[];
  center: google.maps.LatLngLiteral = { lat: 45.8, lng: 15.97 };


  mapOptions: google.maps.MapOptions = {
    tilt: 0,
    mapTypeId: google.maps.MapTypeId.HYBRID,
  };
  showStatsDialog: boolean;
  mapZoom: number = 7;

  markerClicked(marker: StatMarker) {
    this.showLocationDataDialog(marker.statLocationData);
  }

  showLocationDataDialog(data: StatLocation) {
    this.selectedLocationData = data;
    this.showStatsDialog = true;
  }
}

interface StatMarker {
  position: google.maps.LatLngLiteral;
  options: google.maps.MarkerOptions;
  statLocationData: StatLocation;
}
